import React from 'react';
import { Box, Skeleton } from '@mui/material';

const IndicatorsSkeleton = () => {
  return (
    <Box sx={{ px: 0, py: { xs: 1, sm: 2 } }}>
      {/* Header */}
      <Box sx={{ mb: 2 }}>
        <Skeleton variant="text" width={220} height={32} animation="wave" />
        <Skeleton variant="text" width={320} height={18} animation="wave" sx={{ mt: 0.5 }} />
      </Box>

      {/* Search */}
      <Skeleton variant="rounded" width="100%" height={36} animation="wave" sx={{ borderRadius: 1, mb: 1.5 }} />

      {/* Table */}
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2.5, bgcolor: 'background.paper', overflow: 'hidden' }}>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton variant="text" width={120} height={20} animation="wave" />
          <Skeleton variant="text" width={80} height={16} animation="wave" />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, px: 2, py: 1, borderBottom: '2px solid', borderColor: 'divider' }}>
          {[70, 140, 60, 40, 55, 55, 50].map((w, i) => (
            <Skeleton key={i} variant="text" width={w} height={14} animation="wave" />
          ))}
        </Box>
        {Array.from({ length: 12 }).map((_, i) => (
          <Box key={i} sx={{
            display: 'flex', alignItems: 'center', gap: 2,
            px: 2, py: 1.25,
            borderBottom: i < 11 ? '1px solid' : 'none', borderColor: 'divider',
          }}>
            <Skeleton variant="text" width={65} height={18} animation="wave" />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={18} animation="wave" />
              <Skeleton variant="text" width="80%" height={14} animation="wave" sx={{ mt: 0.25 }} />
            </Box>
            <Skeleton variant="rounded" width={55} height={22} animation="wave" sx={{ borderRadius: 1 }} />
            <Skeleton variant="circular" width={18} height={18} animation="wave" />
            <Skeleton variant="text" width={45} height={18} animation="wave" />
            <Skeleton variant="text" width={40} height={18} animation="wave" />
            <Box sx={{ display: 'flex', gap: 0.5 }}>
              <Skeleton variant="circular" width={20} height={20} animation="wave" />
              <Skeleton variant="circular" width={20} height={20} animation="wave" />
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default IndicatorsSkeleton;

